export default __webpack_public_path__ + "static/media/general_eancode.b7abe61b.png";